<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

    <!-- 사업장정보 -->
    <div class="mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 사업장정보</h5>
        </vs-col>
      </vs-row>
      <div class="grid grid-cols-3 gap-x-6 gap-y-4 mt-4">
        <div class="custom-row">
          <div class="label-text mr-4">근로자 수</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputB_1 }}
          </div>
          <ml-input
            v-else
            :readonly="true"
            placeholder="자동입력"
            v-model="form.inputB_1"
            class="w-full flex-1"
          />
        </div>
        <div class="custom-row">
          <div class="label-text mr-4">업종</div>

          <div v-if="isPrint" class="print-input">
            {{ form.inputB_2 }}
          </div>
          <ml-input
            v-else
            :readonly="true"
            placeholder="자동입력"
            v-model="form.inputB_2"
            class="w-full flex-1"
          />
        </div>
        <div class="custom-row">
          <div class="label-text mr-4">소재지</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputB_3 }}
          </div>
          <ml-input
            v-else
            :readonly="true"
            placeholder="자동입력"
            v-model="form.inputB_3"
            class="w-full flex-1"
          />
        </div>
      </div>
    </div>

    <!-- 재해자 인적사항 -->
    <div class="mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 재해자 인적사항</h5>
        </vs-col>
      </vs-row>
      <div class="grid grid-cols-3 gap-x-6 gap-y-4 mt-4">
        <div class="custom-row">
          <div class="label-text mr-4">성명</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputC_1 }}
          </div>
          <ml-input
            v-else
            :readonly="true"
            placeholder="자동입력"
            v-model="form.inputC_1"
            class="w-full flex-1"
          />
        </div>
        <div class="custom-row">
          <div class="label-text mr-4">주민등록번호</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputC_2 }}
          </div>
          <ml-input
            v-else
            readonly
            placeholder="자동입력"
            v-model="form.inputC_2"
            class="w-full flex-1"
          />
        </div>
        <div class="custom-row">
          <div class="label-text mr-4">소속</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputC_3 }}
          </div>
          <ml-input
            v-else
            readonly
            placeholder="자동입력"
            v-model="form.inputC_3"
            class="w-full flex-1"
          />
        </div>
      </div>
      <div class="grid grid-cols-3 gap-x-6 gap-y-4 mt-4">
        <div class="custom-row">
          <div class="label-text mr-4">직종</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputC_4 }}
          </div>
          <ml-input
            v-else
            readonly
            placeholder="자동입력"
            v-model="form.inputC_4"
            class="w-full flex-1"
          />
        </div>
        <div class="custom-row">
          <div class="label-text mr-4">입사일자</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputC_5 }}
          </div>
          <date-selector
            v-else
            readonly
            placeholder="자동입력"
            v-model="form.inputC_5"
            class="w-full flex-1"
          />
        </div>
        <div class="custom-row">
          <div class="label-text mr-4">입사일자</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputC_6 }} 년 {{ form.inputC_7 }} 월
          </div>
          <div v-else class="w-full flex-1 flex items-center gap-2">
            <ml-input
              readonly
              placeholder="자동입력"
              v-model="form.inputC_6"
              class="w-auto"
            />
            년
            <ml-input
              readonly
              placeholder="자동입력"
              v-model="form.inputC_7"
              class="w-auto"
            />
            월
          </div>
        </div>
        <div class="custom-row">
          <div class="label-text mr-4">재해정도:사망(명)</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputC_8 }}
          </div>
          <ml-input
            v-else
            readonly
            placeholder="자동입력"
            v-model="form.inputC_8"
            class="w-full flex-1"
          />
        </div>
        <div class="custom-row">
          <div class="label-text mr-4">재해정도:부상(명)</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputC_9 }}
          </div>
          <ml-input
            v-else
            readonly
            placeholder="자동입력"
            v-model="form.inputC_9"
            class="w-full flex-1"
          />
        </div>
        <div class="custom-row">
          <div class="label-text mr-4">치료예상기간</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputC_10 }} ~ {{ form.inputC_11 }}
          </div>
          <div v-else class="w-full flex-1 flex items-center gap-2">
            <date-selector
              readonly
              placeholder="자동입력"
              v-model="form.inputC_10"
              class="w-auto"
            />
            ~
            <date-selector
              readonly
              placeholder="자동입력"
              v-model="form.inputC_11"
              class="w-auto"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- 재해발생 내용 및 조치현황 -->
    <div class="mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 재해발생 내용 및 조치현황</h5>
        </vs-col>
      </vs-row>
      <div class="grid grid-cols-3 gap-x-6 gap-y-4 mt-4">
        <div class="custom-row">
          <div class="label-text mr-4">재해일시</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputD_1 }}
          </div>
          <date-selector
            v-else
            readonly
            placeholder="자동입력"
            v-model="form.inputD_1"
            class="w-full flex-1"
          />
        </div>
        <div class="custom-row">
          <div class="label-text mr-4">재해장소</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputD_2 }}
          </div>
          <ml-input
            v-else
            readonly
            placeholder="자동입력"
            v-model="form.inputD_2"
            class="w-full flex-1"
          />
        </div>
        <div class="custom-row">
          <div class="label-text mr-4">발생형태</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputD_3 }}
          </div>
          <ml-input
            v-else
            readonly
            placeholder="자동입력"
            v-model="form.inputD_3"
            class="w-full flex-1"
          />
        </div>
      </div>
      <div class="grid grid-cols-3 gap-x-6 gap-y-4 mt-4">
        <div class="custom-row">
          <div class="label-text mr-4">기인물</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputD_4 }}
          </div>
          <ml-input
            v-else
            readonly
            placeholder="자동입력"
            v-model="form.inputD_4"
            class="w-full flex-1"
          />
        </div>
        <div class="custom-row">
          <div class="label-text mr-4">행정조치</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputD_5 }}
          </div>
          <ml-input
            v-else
            readonly
            placeholder="자동입력"
            v-model="form.inputD_5"
            class="w-full flex-1"
          />
        </div>
      </div>
      <div class="print-container col-span-12 flex items-start mt-4">
        <div class="label-text mr-4 mt-2">재해발생 인지경위</div>
        <div v-if="isPrint" class="print-textarea">
          {{ form.inputD_6 }}
        </div>
        <ml-textarea
          v-else
          readonly
          placeholder="자동입력"
          rows="5"
          v-model="form.inputD_6"
          class="flex-1 w-full"
        />
      </div>
      <div class="print-container col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">재해발생경위(육하원칙)</div>
        <div v-if="isPrint" class="print-textarea">
          {{ form.inputD_7 }}
        </div>
        <ml-textarea
          v-else
          readonly
          placeholder="자동입력"
          rows="5"
          v-model="form.inputD_7"
          class="flex-1 w-full"
        />
      </div>
      <div class="print-container col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">조치 및 전망</div>
        <div v-if="isPrint" class="print-textarea">
          {{ form.inputD_8 }}
        </div>
        <ml-textarea
          v-else
          readonly
          placeholder="자동입력"
          rows="5"
          v-model="form.inputD_8"
          class="flex-1 w-full"
        />
      </div>
      <div class="print-container col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">기타 중요한 사항(경찰서 조사관계 등)</div>
        <div v-if="isPrint" class="print-textarea">
          {{ form.inputD_9 }}
        </div>
        <ml-textarea
          v-else
          readonly
          placeholder="자동입력"
          rows="5"
          v-model="form.inputD_9"
          class="flex-1 w-full"
        />
      </div>
    </div>

    <!-- 재해발생 원인분석 및 재발방지 대책 -->
    <div class="mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 재해발생 원인분석 및 재발방지 대책</h5>
        </vs-col>
      </vs-row>
      <div class="grid grid-cols-3 gap-x-6 gap-y-4 mt-4">
        <div class="custom-row">
          <div class="label-text mr-4">산업재해조사표 제출일</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputD_5 }}
          </div>
          <date-selector
            v-else
            :readonly="board.readonly"
            placeholder="날짜선택"
            v-model="form.inputE_1"
            class="w-full flex-1"
          />
        </div>
      </div>
      <div class="print-container col-span-12 flex items-start mt-4">
        <div class="label-text mr-4 mt-2">재해발생 개요</div>
        <div v-if="isPrint" class="print-textarea">
          {{ form.inputE_2 }}
        </div>
        <ml-textarea
          v-else
          :readonly="board.readonly"
          placeholder="입력필드"
          rows="5"
          v-model="form.inputE_2"
          class="flex-1 w-full"
        />
      </div>
      <div class="print-container col-span-12 flex items-start mt-4">
        <div class="label-text mr-4 mt-2">재해발생 원인</div>
        <div v-if="isPrint" class="print-textarea">
          {{ form.inputE_3 }}
        </div>
        <ml-textarea
          v-else
          :readonly="board.readonly"
          placeholder="입력필드"
          rows="5"
          v-model="form.inputE_3"
          class="flex-1 w-full"
        />
      </div>
      <div class="print-container col-span-12 flex items-start mt-4">
        <div class="label-text mr-4 mt-2">재해발생 대책 (단기적 대책)</div>
        <div v-if="isPrint" class="print-textarea">
          {{ form.inputE_4 }}
        </div>
        <ml-textarea
          v-else
          :readonly="board.readonly"
          placeholder="입력필드"
          rows="5"
          v-model="form.inputE_4"
          class="flex-1 w-full"
        />
      </div>
      <div class="print-container col-span-12 flex items-start mt-4">
        <div class="label-text mr-4 mt-2">재해발생 대책 (장기적 대책)</div>
        <div v-if="isPrint" class="print-textarea">
          {{ form.inputE_5 }}
        </div>
        <ml-textarea
          v-else
          :readonly="board.readonly"
          placeholder="입력필드"
          rows="5"
          v-model="form.inputE_5"
          class="flex-1 w-full"
        />
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    />

    <vs-popup
      id="popupReportList"
      title="중대재해 발생 보고"
      :active.sync="showPopup"
    >
      <div class="w-full flex flex-row justify-between items-center gap-4 p-6">
        <div class="flex-1 flex flex-row items-center gap-4">
          <search-nav-start-end label="작성일" v-model="search.date" name="244-popup-search-1" />
          <search-nav-item-select
            label="발생형태"
            v-model="search.disasterType"
            :list="disasterTypes"
            name="244-popup-search-2"
          />
          <search-nav-item-select
            :label="$t('search.검색조건')"
            v-model="search.searchType"
            :list="searchTypes"
            name="244-popup-search-3"
          />
          <search-nav-item-keyword
            :label="$t('search.키워드')"
            v-model="search.searchKeyword"
            name="244-popup-search-4"
          />
        </div>
        <vs-button color="secondary" @click="handleClickSearch">
          검색
        </vs-button>
      </div>
      <vs-table
        stripe
        ref="table"
        :sst="true"
        :max-items="page.perPage"
        :data="reportList"
        noDataText="데이터가 없습니다"
      >
        <template slot="thead">
          <vs-th class="w-1/12" style="min-width: 100px"> No. </vs-th>
          <vs-th class="w-1/12" style="min-width: 100px"> 사업장명 </vs-th>
          <vs-th class="w-1/12" style="min-width: 100px"> 재해일시 </vs-th>
          <vs-th class="w-1/12" style="min-width: 100px"> 발생형태 </vs-th>
          <vs-th class="w-1/12" style="min-width: 100px"> 소속명 </vs-th>
          <vs-th class="w-1/12" style="min-width: 100px"> 부서명 </vs-th>
          <vs-th class="w-1/12" style="min-width: 100px"> 작성자 </vs-th>
          <vs-th class="w-1/12" style="min-width: 100px"> 작성일 </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr
            v-for="(item, index) in data"
            :key="index"
            class="cursor-pointer"
            @click.native="() => handleItemClickDetail(item)"
          >
            <vs-td>{{ item.id }}</vs-td>
            <vs-td>{{ item.stdInfo.field_name }}</vs-td>
            <vs-td>{{ item.inputD_1 }}</vs-td>
            <vs-td>{{ item.inputD_3 }}</vs-td>
            <vs-td>{{ item.stdInfo.department }}</vs-td>
            <vs-td>{{ item.stdInfo.section }}</vs-td>
            <vs-td>{{ item.stdInfo.writer_name }}</vs-td>
            <vs-td>{{ item.stdInfo.date }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="vs-con-table mb-6">
        <div class="con-pagination-table vs-table--pagination">
          <k-pagination
            :total="page.lastPage ? page.lastPage : 1"
            :value="page.current"
            @change="handleChangePage"
          />
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TrainingDisasterClassSelector from "@/components/selector/TrainingDisasterClassSelector";
import KPagination from "@/components/kPagination/kPagination";
import SearchNavStartEnd from "@/components/nav/SearchNavStartEnd.vue";
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";
import { valueDisasters } from "@/util/DisasterDataUtil";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    TrainingDisasterClassSelector,
    KPagination,
    SearchNavStartEnd,
    SearchNavItemKeyword,
    SearchNavItemSelect,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {
    reportList() {
      if (this.$store.state.board.postListInfo.data) {
        return this.$store.state.board.postListInfo.data.map((item) => {
          return { id: item.id, ...this.getContent(item).body };
        });
      } else return [];
    },
  },
  data() {
    return {
      customButton: null,
      showPopup: false,
      disasterTypes: [{ text: "전체선택", value: "" }, ...valueDisasters()],
      searchTypes: [
        { value: "stdInfo.field_name", text: "사업장명" },
        { value: "inputD_1", text: "재해일시" },
        { value: "inputD_3", text: "발생형태" },
        { value: "stdInfo.department", text: "소속명" },
        { value: "stdInfo.section", text: "부서명" },
        { value: "stdInfo.writer_name", text: "작성자" },
      ],

      // 페이징
      page: {
        current: 1,
        lastPage: 1,
        perPage: 10,
      },

      // 검색
      search: {
        date: "", // 작성일
        disasterType: "", // 발생형태
        searchType: "", // 검색조건
        searchKeyword: "", // 키워드
      },

      form: {
        stdInfo: {},

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",

        inputC_1: "",
        inputC_2: "",
        inputC_3: "",
        inputC_4: "",
        inputC_5: "",
        inputC_6: "",
        inputC_7: "",
        inputC_8: "",
        inputC_9: "",
        inputC_10: "",
        inputC_11: "",

        inputD_1: "",
        inputD_2: "",
        inputD_3: "",
        inputD_4: "",
        inputD_5: "",
        inputD_6: "",
        inputD_7: "",
        inputD_8: "",
        inputD_9: "",

        inputE_1: "",
        inputE_2: "",
        inputE_3: "",
        inputE_4: "",
        inputE_5: "",

        fileList: [],
      },
    };
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.summary = {
          중대재해발생_사업장명: [],
          중대재해발생_재해형태: [],
        };

        value.summary["중대재해발생_사업장명"].push({
          [this.form.stdInfo.field_name]: 1,
        });

        value.summary["중대재해발생_재해형태"].push({
          [this.form.inputD_3]: 1,
        });

        this.$emit("input", value);
      },
    },
  },
  mounted() {
    /** 재해 발생 보고서 불러오기 버튼 추가 */
    this.customButton = document.createElement("button");
    this.customButton.className =
      "vs-component vs-button ml-4 vs-button-secondary vs-button-border";
    this.customButton.innerText = "재해 발생 보고서 불러오기";
    this.customButton.addEventListener("click", this.onClickLoadBtn);

    const btnsContainer = document.getElementById("right-button-container");
    btnsContainer.insertAdjacentElement("afterbegin", this.customButton);
  },
  destroyed() {
    this.customButton.removeEventListener("click", this.onClickLoadBtn);
  },
  methods: {
    onClickLoadBtn() {
      this.loadReport();
      this.showPopup = true;
    },
    handleClickSearch() {
      this.page.current = 1;
      this.loadReport();
    },
    handleChangePage(page) {
      this.page.current = page;
      this.loadReport();
    },
    async loadReport() {
      const boardId = 244;
      const projectId = this.$route.params.proj_id;
      const page = this.page.current;
      const perPage = this.page.perPage;

      const { date, disasterType, searchType, searchKeyword } = this.search;
      const keyword = [];
      if (disasterType) keyword.push(`content$body.inputD_3*${disasterType}`);
      if (!!searchType && !!searchKeyword) keyword.push(`content$body.${searchType}*%${searchKeyword}%`);

      await this.$store.dispatch("board/LOAD_POST_LIST", {
        projectId,
        boardId,
        page,
        perPage,
        dateBegin: date.sDate,
        dateEnd: date.eDate,
        keyword,
      });

      const data = this.$store.state.board.postListInfo;
      this.page.current = data.current_page;
      this.page.lastPage = data.last_page;
    },
    handleItemClickDetail(data) {
      this.form.inputB_1 = data.inputB_1;
      this.form.inputB_2 = data.inputB_2;
      this.form.inputB_3 = data.inputB_3;

      this.form.inputC_1 = data.inputC_1;
      this.form.inputC_2 = data.inputC_2;
      this.form.inputC_3 = data.inputC_3;
      this.form.inputC_4 = data.inputC_4;
      this.form.inputC_5 = data.inputC_5;
      this.form.inputC_6 = data.inputC_6;
      this.form.inputC_7 = data.inputC_7;
      this.form.inputC_8 = data.inputC_8;
      this.form.inputC_9 = data.inputC_9;
      this.form.inputC_10 = data.inputC_10;
      this.form.inputC_11 = data.inputC_11;

      this.form.inputD_1 = data.inputD_1;
      this.form.inputD_2 = data.inputD_2;
      this.form.inputD_3 = data.inputD_3;
      this.form.inputD_4 = data.inputD_4;
      this.form.inputD_5 = data.inputD_5;
      this.form.inputD_6 = data.inputD_6;
      this.form.inputD_7 = data.inputD_7;
      this.form.inputD_8 = data.inputD_8;
      this.form.inputD_9 = data.inputD_9;

      this.showPopup = false;
    },
    getContent(data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content);
        return content;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.custom-row {
  align-items: center;
  display: flex;
  width: 100%;
  //grid-template-columns: 114px 1fr;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  //padding-right: 12px;
}

#popupReportList::v-deep > .vs-popup {
  width: 90vw !important;
}
</style>
